import { storage } from '../storage';

const MINIMIZED_POPUPS_KEY = 'minimized-popups';

// Recupero la lista di tutti i popup minimizzati persistente nel localStorage
export const getStoredMinimizedPopups = () => storage.getObject<Array<string>>(MINIMIZED_POPUPS_KEY, true) || [];

const setStoredMinimizedPopups = (minimizedPopups: Array<string>) =>
  storage.setObject(MINIMIZED_POPUPS_KEY, minimizedPopups, true);

// Aggiungo un popup minimizzato alla lista persistente nel localStorage
export const addStoredMinimizedPopup = (popupId: string) => {
  const minimizedPopups = getStoredMinimizedPopups();
  minimizedPopups.push(popupId);
  setStoredMinimizedPopups(minimizedPopups);
};

// Rimuovo un popup minimizzato dalla lista persistente nel localStorage
export const removeStoredMinimizedPopup = (popupId: string) => {
  const minimizedPopups = getStoredMinimizedPopups();
  const filtered = minimizedPopups.filter((id) => id !== popupId);
  setStoredMinimizedPopups(filtered);
};
